"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchObservable = batchObservable;
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var batch = [];
function processBatch() {
    for (var _i = 0, batch_1 = batch; _i < batch_1.length; _i++) {
        var item = batch_1[_i];
        item.observableValue.set(item.value);
    }
}
function resolveBatch() {
    (0, mobx_1.transaction)(processBatch);
    batch.length = 0;
}
var resolveBatchTask = new core_shared_1.IkeDelayedTask(resolveBatch, 100);
function ensureObservable(target, observableName) {
    if (target[observableName] != null) {
        return target[observableName];
    }
    var observableValue = mobx_1.observable.box(null, { name: observableName, deep: false });
    target[observableName] = observableValue;
    return observableValue;
}
/** mobx.observable which sets immediatly but notifies after a short delay */
function batchObservable(target, propertyName) {
    var observableName = '_' + propertyName;
    var internalValueName = '__' + propertyName;
    Object.defineProperty(target, propertyName, {
        enumerable: true,
        get: function () {
            var observableValue = ensureObservable(this, observableName);
            observableValue.get();
            return this[internalValueName];
        },
        set: function (value) {
            var observableValue = ensureObservable(this, observableName);
            // Set value immediatly for sync get
            this[internalValueName] = value;
            // Delay mobx set to batch reactions
            batch.push({ observableValue: observableValue, value: value });
            resolveBatchTask.delay();
        }
    });
}
//# sourceMappingURL=batch.observable.js.map